define('views/wellness/partner/resource',[
    'backbone',
    'views/_base/baseview',
    'text!views/wellness/partner/resource.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        tagName : 'li',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click a' : 'showPartnerResource'
        },
        initialize: function(options){
            options = options || {};
            
            this.elementName = options.elementName;

            this.resource = (options.data) ? options.data : {};

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.buildLogoImg();

            this.$el.addClass(pf.getContent('wellness.content.panel.resources.class')).html(this.template());

            return this;
        },

        loadData: function(){},

        buildLogoImg: function(){
            var logo = pf.imageURL + this.resource.image_url;

            this.resource.logo = logo;
        },

        showPartnerResource: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            console.log('showPartnerResource',this);

            if(this.resource){
                window.open(this.resource.link_url);
            }

        },

        close: function(){}
    });
});

